import { useMutation, useQueryClient } from "@tanstack/react-query"
import { getOrganizationAxios } from "api-hooks/get-organization-axios"

interface ConnectWebviewCustomizationInput {
  primary_button_color?: string | null
  primary_button_text_color?: string | null
  logo_shape?: "circle" | "square" | null
}

interface UpdateOrganizationParams {
  organization_id: string
  name?: string
  logo_image_base64?: string | null
  connect_webview_customization?: ConnectWebviewCustomizationInput
}

interface UpdateOrganizationResponse {
  organization: {
    organization_id: string
    name: string
    logo_url: string | null
    connect_webview_customization: {
      primary_button_color: string | null
      primary_button_text_color: string | null
      logo_shape: "circle" | "square" | null
    }
    created_at: string
    updated_at: string
  }
}

export const useUpdateOrganization = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (
      params: UpdateOrganizationParams
    ): Promise<UpdateOrganizationResponse> => {
      const axios = getOrganizationAxios()
      const { data } = await axios.post(
        "/seam/console/v1/organizations/update",
        params
      )
      return data
    },
    onSuccess: (_, variables) => {
      qc.invalidateQueries({ queryKey: ["organizations"] })
      qc.invalidateQueries({
        queryKey: ["organizations", variables.organization_id],
      })
    },
  })
}
